import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "migration-guides"
    }}>{`Migration guides`}</h1>
    <h2 {...{
      "id": "migration-guides-for-adobe-experience-platform-sdks-for-android"
    }}>{`Migration guides for Adobe Experience Platform SDKs for Android`}</h2>
    <p>{`Learn how to `}<a parentName="p" {...{
        "href": "./android/index.md"
      }}>{`migrate between different versions of Adobe Experience Platform SDKs for Android`}</a>{`.`}</p>
    <h2 {...{
      "id": "migration-guides-for-adobe-experience-platform-sdks-for-ios"
    }}>{`Migration guides for Adobe Experience Platform SDKs for iOS`}</h2>
    <p>{`Learn how to `}<a parentName="p" {...{
        "href": "./ios/index.md"
      }}>{`migrate between different versions of Adobe Experience Platform SDKs for iOS`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      